var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSabaIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.92722e-06C15.9851 -0.0112441 -0.00424915 15.9958 8.47096e-07 16C8.47096e-07 7.16351 7.1635 5.92722e-06 16 5.92722e-06Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.92725e-06C16.0149 -0.0112441 32.0042 15.9958 32 16C32 7.16351 24.8365 5.92725e-06 16 5.92725e-06Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C15.9851 32.0112 -0.00424915 16.0043 8.47096e-07 16C8.47096e-07 24.8365 7.1635 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16.0149 32.0112 32.0042 16.0043 32 16C32 24.8365 24.8365 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.3479L17.7267 13.6622H23.3145L18.7939 16.9466L20.5206 22.261L16 18.9765L11.4794 22.261L13.2061 16.9466L8.68549 13.6622H14.2732L16 8.3479Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSabaIsland);
export default __webpack_public_path__ + "static/media/flag_saba_island.357bcc833309d056957e246c18a1cc9f.svg";
export { ForwardRef as ReactComponent };